import classNames from "classnames";
import { memo } from "react";
import * as loadingRedoAnimationCss from "./loading-redo-animation.module.css";
import { RedoSpinner, RedoSpinnerColor } from "./loading/redo-spinner";

export const LoadingRedoAnimation = memo(function LoadingRedoAnimation({
  color = "inherit",
  className,
  dataUi,
}: {
  color?: RedoSpinnerColor;
  className?: string;
  dataUi?: string;
}) {
  return (
    <div
      className={classNames(loadingRedoAnimationCss.loadingSpinner, className)}
      data-ui={dataUi}
      data-web="LoadingRedoAnimation"
    >
      <RedoSpinner color={color} size="md" />
    </div>
  );
});
